var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-paypal-form',{attrs:{"total":_vm.total},on:{"success":_vm.onSuccess,"error":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }